<template>
  <div>
    <el-card body-style="padding: 0">
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">商家充值统计</span>
      </div>
      <el-form ref="queryForm" :model="queryForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="时间段" prop="timeRange">
              <el-date-picker
                  v-model="queryForm.timeRange"
                  type="datetimerange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="8" :offset="6">
            <el-form-item>
              <el-button type="primary" size="small"
                         @click="submitQueryForm()" icon="el-icon-search">
                查询
              </el-button>
              <el-button type="primary" size="small" plain
                         @click="resetQueryForm()" icon="el-icon-refresh">
                重置
              </el-button>
              <el-button type="primary" size="small" plain
                         @click="exportDepositData()" icon="el-icon-refresh">
                导出
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <el-table :data="tableData"
                border default-expand-all stripe
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%;margin-bottom: 20px;"
                :cell-style="{'text-align':'center'}">
        <el-table-column prop="id" label="序号"/>
        <el-table-column prop="investDate" label="充值日期"/>
        <el-table-column prop="investMoney" label="充值金额"/>
        <el-table-column prop="remarks" label="备注"/>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {getUsersMoneyChangeRecords} from "../../api/b2cbusiness/b2c_investmoney";
import qs from "qs";

export default {
  name: "DepositReports",
  mixins: [MixinCUD],
  data() {
    return {
      tableData: [],
      queryFormRefName:"queryForm",
      queryForm: {
        timeRange:[],
      },
      tmpRange:[],
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  mounted() {
    this.getPassYearFormatDate();
    this.getData();
  },
  methods: {
    exportDepositData(){
      window.open("https://api.weiquanai.com/b2cinvestmoney/exportinvestmony?"+qs.stringify({
        startTime: this.queryForm.timeRange?this.queryForm.timeRange[0]:null,
        endTime: this.queryForm.timeRange?this.queryForm.timeRange[1]:null,
      }), "_blank");
    },
    getData() {
      if (this.queryForm.timeRange.length <= 0){
        this.queryForm.timeRange = this.tmpRange;
        console.log(this.queryForm, this.tmpRange)
      }
      getUsersMoneyChangeRecords(this.queryForm).then(res => {
        if (res.success) {
          this.tableData = res.data;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    getPassYearFormatDate () {
      let nowDate = new Date()
      let date = new Date(nowDate)
      date.setDate(date.getDate() - 5)
      let seperator1 = '-'
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      let formatDate = year + seperator1 + month + seperator1 + strDate + " 00:"+ "00:"+ "00"
      this.getNowFormatDate(formatDate)
    },
    getNowFormatDate (formatDate) {
      let date = new Date()
      let seperator1 = '-'
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      let nowData = year + seperator1 + month + seperator1 + strDate + " 23:"+ "59:"+ "59";
      this.tmpRange= [formatDate, nowData] ;
      //console.log(this.queryForm)
      this.$forceUpdate();
    }
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}
</style>
